import { nextTick } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { useUserStore } from '@/entities/user';
import { lazyPage } from '@/shared/lib';
import { RouterPages, RouterPaths } from '@/shared/router';

import { chatRoutes } from './chat';
import { errorRoutes } from './error';
import { privacyRoutes } from './privacy';

const routes: RouteRecordRaw[] = [
  ...chatRoutes,
  ...privacyRoutes,
  ...errorRoutes,

  {
    name: RouterPages.INDEX,
    path: RouterPaths.INDEX,
    component: lazyPage(() => import('@/pages/home'), 'HomePage'),
    beforeEnter: async () => {
      const userStore = useUserStore();

      if (!userStore.isFetched) {
        await userStore.fetchUser();
        await nextTick();
      }

      if (userStore.isAuth) {
        return { name: RouterPages.CHAT };
      }

      return;
    },
    meta: {
      ignoreAuth: true,
    },
  },
] as const;

export { routes };
